import * as React from 'react';

import { translate } from '~l10n/client';
import cx from 'classnames';

import { FocusIndicator } from '../FocusIndicator/FocusIndicator';

interface MathButtonProps {
  onClick?: () => void;
  isMathFormulaSelected: boolean;
}

const QuillToolBarMathButton = ({
  onClick,
  isMathFormulaSelected,
}: React.PropsWithChildren<MathButtonProps>) => {
  const text = isMathFormulaSelected ? translate('Edit') : translate('Insert');

  const className = cx(
    'relative flex-none h-8 min-w-8 px-2 py-1 m-0',
    'font-sans text-xs text-grey-700 border-0 bg-transparent rounded-1',
    'cursor-pointer outline-none transition-colors duration-100 ease-linear',
    'toolbar-button toolbar-button--math',
    {
      'ql-active': isMathFormulaSelected,
    }
  );

  return (
    <button
      className={className}
      data-testid="math"
      type="button"
      onClick={onClick}
      aria-label={translate('Equation')}
    >
      <FocusIndicator
        notOffset
        isInset={!isMathFormulaSelected}
        includesWhiteInset={isMathFormulaSelected}
      />
      <div className="flex items-center justify-center font-600">
        <div className="toolbar-button__label">{text}</div>
        <svg width="18" height="18" viewBox="0 0 18 18">
          <path
            fill="currentColor"
            fillRule="nonzero"
            d="M11.759 2.482a.966.966 0 01-.658 1.602 1.014 1.014 0 01-1.02-.56c-.471.146-.877 1.136-1.242 2.442l-.064.234h.575a.8.8 0 110 1.6h-.966l-.011.047c-.146.656-.285 1.326-.42 1.968l-.134.632C7.21 13.309 6.284 16 4.119 16c-2.016 0-2.115-.836-2.119-.95v-.014a.922.922 0 01.85-1.042 1.545 1.545 0 011.3.933c.944-.21 1.684-4.112 2.306-7.127H5.95a.8.8 0 110-1.6h.85a7.656 7.656 0 011.429-3.111 2.561 2.561 0 013.53-.607zM9.99 10.341c.447-.184 2.482-1.047 2.941.8.075.303.144.597.212.885l.246-.38c.085-.13.157-.246.218-.346.213-.368.476-.704.781-1 .214-.194.492-.301.781-.3a.8.8 0 01.594.239.84.84 0 01.238.619c.015.3-.1.59-.314.8a1.075 1.075 0 01-.767.3 2.1 2.1 0 01-.535-.069 5.572 5.572 0 01-.456-.138 1.662 1.662 0 00-.266.276c-.117.142-.25.318-.4.527l.038.292c.124.774.423 1.51.875 2.154a.807.807 0 00.951.051c.212-.071.317.313 0 .494a2.582 2.582 0 01-2.376.185 2.786 2.786 0 01-.918-1.726c-.101.152-.177.27-.223.346-.05.08-.121.194-.215.34a5.11 5.11 0 01-.776.993 1.134 1.134 0 01-.787.3.82.82 0 01-.832-.852 1.058 1.058 0 011.085-1.113c.176 0 .352.021.522.066.167.045.324.094.471.147a2.69 2.69 0 00.264-.271c.129-.15.25-.305.362-.467-.15-.602-.31-1.287-.527-2.038a.869.869 0 00-1.281-.585c-.259.118-.388-.329.094-.529z"
          />
        </svg>
      </div>
    </button>
  );
};

export default QuillToolBarMathButton;
